import React from "react";

const ActionButtonsSettings = () => {
  return (
    <div className="field is-grouped">
      <div className="control">
        <button className="button is-primary" type="submit">
          Guardar Alterações
        </button>
      </div>
      <div className="control">
        <button className="button is-light" type="reset">
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default ActionButtonsSettings;
